<script setup lang="ts">
import type { CustomVars, I18nStrings } from './interfaces'

defineProps<{
  customVar: CustomVars
  i18nStrings: I18nStrings
  isSelected?: boolean
}>()
</script>

<template>
  <div
    class="cursor-pointer px-4 py-3"
    :class="{
      'bg-yellow-50': customVar.disabled && isSelected,
      'bg-muted': !customVar.disabled && isSelected,
      'hover:bg-muted/50': !customVar.disabled && !isSelected
    }"
  >
    <div class="flex flex-col">
      <div class="flex flex-row items-start" :class="customVar.disabled ? 'text-foreground-disabled' : 'text-blue-600'">
        <label class="mr-2 block cursor-pointer text-base font-medium leading-5 flex-1">
          {{ customVar.label }}
        </label>
      </div>
      <p
        v-if="customVar.disabled && customVar.disabledMessage"
        :class="[
          customVar.disabled && isSelected ? 'text-yellow-500 font-medium' : 'text-muted-foreground',
          'mt-1 text-xs italic'
        ]"
      >
        {{ customVar.disabledMessage }}
      </p>

      <p class="mt-1 text-xs text-foreground">
        <i class="text-muted-foreground">{{ customVar.length }}&nbsp;{{ i18nStrings.characters }}</i>
      </p>
    </div>
  </div>
</template>
